export default __webpack_public_path__ + "static/media/icon_acc_game.b4f61751.svg";